'use client';


import { Icon, forwardRef, useStyleConfig } from "@chakra-ui/react";
import { c } from "react-compiler-runtime";
import React from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/Icon/Icon.tsx
const Icon$1 = forwardRef((t0, ref) => {
	const $ = c(15);
	let color;
	let props;
	let size;
	if ($[0] !== t0) {
		({size, color, ...props} = t0);
		$[0] = t0;
		$[1] = color;
		$[2] = props;
		$[3] = size;
	} else {
		color = $[1];
		props = $[2];
		size = $[3];
	}
	let AsComponent;
	let rest;
	if ($[4] !== props) {
		({as: AsComponent, ...rest} = props);
		$[4] = props;
		$[5] = AsComponent;
		$[6] = rest;
	} else {
		AsComponent = $[5];
		rest = $[6];
	}
	let t1;
	if ($[7] !== color || $[8] !== size) {
		t1 = {
			size,
			color
		};
		$[7] = color;
		$[8] = size;
		$[9] = t1;
	} else t1 = $[9];
	const styles = useStyleConfig("Icon", t1);
	let t2;
	if ($[10] !== AsComponent || $[11] !== ref || $[12] !== rest || $[13] !== styles) {
		t2 = /* @__PURE__ */ jsx(Icon, {
			ref,
			sx: styles,
			as: AsComponent,
			...rest
		});
		$[10] = AsComponent;
		$[11] = ref;
		$[12] = rest;
		$[13] = styles;
		$[14] = t2;
	} else t2 = $[14];
	return t2;
});

//#endregion
export { Icon$1 as Icon };
//# sourceMappingURL=Icon.js.map